import React from 'react';
import { primaryColumnLink } from './styles';
import DataCell from './DataCell';

const cell = {
    textAlign: 'left'
};

const TextDataCell = ({
    rowIndex,
    data,
    accessor,
    primaryColumn,
    onPrimaryColumnClick,
    scrollPxH,
    scrollPxV,
    isSticky,
    style,
    onHover,
    isHighlighted,
    rowHeight,
    deleteRowSelected,
    highlightedIdx,
    setHighlightedIdx,
    highlightOnClick = false
}) => {
    return (
        <DataCell
            rowIndex={rowIndex}
            scrollPxH={scrollPxH}
            scrollPxV={scrollPxV}
            id={`${accessor}${rowIndex}`}
            style={{ height: rowHeight, ...cell, ...style }}
            isSticky={isSticky}
            onHover={onHover}
            isHighlighted={isHighlighted}
            deleteRowSelected={deleteRowSelected}
            highlightedIdx={highlightedIdx}
            setHighlightedIdx={setHighlightedIdx}
            highlightOnClick={highlightOnClick}
        >
            {accessor === primaryColumn ? (
                <span
                    style={primaryColumnLink}
                    onClick={() => onPrimaryColumnClick(data)}
                >
                    {data[accessor]}
                </span>
            ) : (
                data[accessor]
            )}
        </DataCell>
    );
};

export default TextDataCell;
